<!-- 配置流程节点 -->
<template>
  <div
    :class="[
      'config-node-page',
      {
        'config-node-page-no': !warehouseContract.length,
      }
    ]"
  >
    <template v-if="warehouseContract.length">
      <div v-if="$route.query.source !== 'configCenter'" class="step-wrapper">
        <div
          v-for="(item,index) in processStepWareHouse"
          :key="index"
          class="step-item"
          :class="{'active':activeStep===index, 'usable':!item.disable}"
          @click="handleClick(item,index)"
        >
          <div class="number">
            {{ index+1 }}
          </div>
          <div class="name">
            {{ item.title }}
          </div>
          <i v-show="index+1!==processStepWareHouse.length" class="el-icon-arrow-right" />
        </div>
      </div>
      <!-- 创建订单 -->
      <createOrderWareHouse
        v-if="activeStep==0"
        ref="createOrderRef"
        :parent-process-name="customersDetail.parentProcessName"
        :parent-process-code="customersDetail.parentProcessCode"
        :custom-field="customField"
        :customer-code="customersDetail.customerCode"
        :customers-detail="customersDetail"
        :form="warehouseConfig"
      />

      <!-- 接单 -->
      <receiveOrderWareHouse
        v-if="activeStep==1"
        ref="receiveOrderRef"
        :form.sync="warehouseConfig"
        :parent-process-code="customersDetail.parentProcessCode"
        @addOrCondition="addOrCondition"
        @addAdnCondition="addAdnCondition"
        @delete="Delete"
        @OrDelete="handleOrDelete"
      />

      <!-- 转派 -->
      <shipperCreateWareHouse
        v-if="activeStep==2"
        ref="shipperOrderRef"
        :form="warehouseConfig"
        :customers-detail="customersDetail"
        :parent-process-name="customersDetail.parentProcessName"
        :parent-process-code="customersDetail.parentProcessCode"
        :is-exist-white="isExistWhite"
        :customer-code="customersDetail.customerCode"
        @addOrCondition="addOrCondition"
        @addAdnCondition="addAdnCondition"
        @delete="Delete"
        @OrDelete="handleOrDelete"
        @addTactics="addTactics"
        @addTacticsProject="addTacticsProject"
        @deleteTacticsProject="deleteTacticsProject"
      />

      <!-- 底部 -->
      <div v-if="activeStep!==4">
        <fix-boottom :class="{'bottom_bar': true, 'bottom_bar_0': $route.query.source === 'configCenter'}">
          <template slot="button">
            <el-button
              type="primary"
              :loading="onlyDisabled"
              @click="handleSubmit"
            >
              {{ $route.query.source === 'configCenter' ? '保存' : '保存并下一步' }}
            </el-button>
            <el-button v-if="$route.query.source !== 'configCenter'" @click="onReturn">
              取消
            </el-button>
          </template>
        </fix-boottom>
      </div>
    </template>
    <div v-else class="no-ware-house-contract">
      <span>当前客户未签约仓储服务合同</span>
    </div>
  </div>
</template>

<script>
import FixBoottom from '@/components/FixBoottom/index.vue';
import {
  getContractAllTypeList,
} from '@/api/configure/ownerRule';
import { localStorageGet } from '@/utils/localStorage';
import { USER } from '@/constant/storage';
import { customerProcessRuleUpdate, customerProcessRuleCreate } from '../api';
import { processModuleCode, processStepWareHouse } from '../const';
import createOrderWareHouse from '../components/createOrderWareHouse.vue';
import receiveOrderWareHouse from '../components/receiveOrderWareHouse.vue';
import shipperCreateWareHouse from '../components/shipperCreateWareHouse.vue';

export default {
  components: {
    createOrderWareHouse, receiveOrderWareHouse, shipperCreateWareHouse, FixBoottom,
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    customField: {
      type: Object,
      default: () => { },
    },
    editProcessStep: {
      type: Number,
      default: -1,
    },
    status: {
      type: String,
      default: null,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    customersDetail: {
      type: Object,
      default: () => {},
    },
    isExistWhite: {
      type: Boolean,
      default: false,
    },
    warehouseConfig: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      processStepWareHouse,
      processModuleCode,
      activeStep: 0,
      onlyDisabled: false,
      warehouseContract: [],
      userInfo: localStorageGet(USER),
    };
  },
  watch: {
    editProcessStep: {
      handler(val) {
        // 非草稿状态,
        if (this.status !== 'DRAFT') {
          this.activeStep = 0;
          return;
        }
        // 草稿状态
        if (!val || val === -1) {
          this.activeStep = 0;
          return;
        }
        this.activeStep = val > 2 ? 2 : val;
      },
      immediate: true,
    },
  },
  mounted() {
    this.getWareHouseContractList();
  },
  methods: {
    handleClick(item, index) {
      if (item.disable) {
        return;
      }
      // if (index > 2 && index !== 4 && index !== 5 && index !== 6) {
      //   return;
      // }
      // if (index > (this.editProcessStep + 1)) {
      //   return;
      // }
      this.activeStep = index;
    },
    handleBefore() {
      // 上一步
      if (this.activeStep !== 0) {
        this.activeStep -= 1;
        return;
      }
      this.$emit('handleBefore');
    },
    async handleNext() {
      // 下一步
      if (this.activeStep === 0) {
        this.handleCreateOrder();
        return;
      }
      if (this.activeStep === 1) {
        this.handleReceiveOrder();
      }
    },
    async handleEnter(module, form) {
      const {
        customerCode, carrierTenantId, parentProcessCode, ruleVersion,
      } = this.customersDetail;
      try {
        const params = {
          customerCode,
          carrierTenantId,
          parentProcessCode,
          ruleVersion,
          processModuleCode: 'WAREHOUSE_ORDER',
          processRules: [
            {
              ruleCode: 'WAREHOUSE_FLOW_CONFIG',
              ruleValue: form,
            },
          ],
        };
        const method = !this.isEdit ? customerProcessRuleCreate : customerProcessRuleUpdate;
        await method(params);
      } catch (e) {
        console.log('e: ', e);
      }
    },
    async handleCreateOrder() {
      // 创建订单
      const { form } = await this.$refs.createOrderRef.valiForm();
      const module = 'CREATE_ORDER';
      try {
        this.onlyDisabled = true;
        await this.handleEnter(module, form);
        this.$emit('getConfigNodeParams', {
          key: module,
          formParams: form,
        });
        this.activeStep += 1;
        this.onlyDisabled = false;
      } catch (e) {
        this.onlyDisabled = false;
      }
    },
    async handleReceiveOrder() {
      // 接单
      const { form } = await this.$refs.receiveOrderRef.valiForm();
      const module = 'RECEIVE_ORDER';
      try {
        this.onlyDisabled = true;
        await this.handleEnter(module, form);
        this.$emit('getConfigNodeParams', {
          key: module,
          formParams: form,
        });
        this.activeStep += 1;
        this.onlyDisabled = false;
      } catch (e) {
        this.onlyDisabled = false;
      }
    },
    async handleShipperOrder() {
      // 转派
      const { form } = await this.$refs.shipperOrderRef.valiForm();
      const module = 'SHIPPER_ORDER';
      try {
        this.onlyDisabled = true;
        await this.handleEnter(module, form);
        this.$emit('getConfigNodeParams', {
          key: module,
          formParams: form,
        });
        this.$emit('allConfig');
        this.onlyDisabled = false;
      } catch (e) {
        this.onlyDisabled = false;
      }
    },
    handleSubmit() {
      // 提交
      switch (this.activeStep) {
        case 0:
          this.handleCreateOrder();
          break;
        case 1:
          this.handleReceiveOrder();
          break;
        case 2:
          this.handleShipperOrder();
          break;
        default:
          break;
      }
    },
    handleSubmitSuccess() {
      // this.$emit('allConfig');
      this.activeStep += 1;
    },
    onReturn() {
      this.$router.go(-1);
    },
    addOrCondition(module, ruleCode) {
      this.$emit('addOrCondition', module, ruleCode);
    },
    addAdnCondition(index, module, ruleCode) {
      this.$emit('addAdnCondition', index, module, ruleCode);
    },
    Delete(value, module, ruleCode) {
      this.$emit('delete', value, module, ruleCode);
    },
    handleOrDelete(value, module, ruleCode) {
      this.$emit('OrDelete', value, module, ruleCode);
    },
    addTactics(module, ruleCode) {
      this.$emit('addTactics', module, ruleCode);
    },
    addTacticsProject(data, module, ruleCode) {
      this.$emit('addTacticsProject', data, module, ruleCode);
    },
    deleteTacticsProject(data, module, ruleCode) {
      this.$emit('deleteTacticsProject', data, module, ruleCode);
    },
    async getWareHouseContractList() {
      try {
        const {
          customerCode,
        } = this.customersDetail;
        const params = {
          cargoOwnerCode: customerCode,
        };
        const { STORAGE } = await getContractAllTypeList(params);
        console.log('getContractAllTypeList--', STORAGE);
        this.warehouseContract = STORAGE || [];
      } catch (e) {
        console.log('getContractAllTypeList-err--', e);
        this.warehouseContract = [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.config-node-page{
  width:100%;
  flex:1;
  background: #fff;
  box-sizing: border-box;
  position:relative;
  margin-bottom: 40px;
  .step-wrapper{
    display:flex;
    padding:24px 24px 0;
    position: sticky;
    top:0;
    left:0;
    background: #fff;
    z-index:100;
    .step-item{
      flex:1;
      border-bottom:1px solid #EBECEE;
      display: flex;
      align-items: center;
      padding-bottom:9px;
      box-sizing: border-box;
      cursor: pointer;
      .number{
        width:20px;
        height:20px;
        text-align: center;
        line-height: 20px;
        border-radius: 100%;
        border:2px solid #B3B7BE;
        color:#B3B7BE;
        margin-right: 8px;
      }
      .name{
        color:#B3B7BE;
        font-weight: 500;
        flex:1;
      }
      .el-icon-arrow-right{
        color:#D9DBDE;
        margin-right:20px;
      }
    }
    .usable{
      .number{
        color: #7E8694 ;
        border:2px solid #7E8694;
      }
      .name{
        color: #7E8694 ;
      }
    }
    .active{
      border-bottom-color: #059E84;
      .number{
        color:#fff;
        background:#059E84;
        border-color: #059E84;
      }
      .name{
        color:#059E84;
        font-weight:600
      }
    }
  }
  .next-wrapper{
    text-align: center;
    border-bottom: 1px solid #D9DBDE;
    padding:16px;
    box-sizing: border-box;
  }
  .fixed-footer{
    height:56px;
    line-height: 56px;
    position:absolute;
    bottom:-24px;
    left:-24px;
    width:calc(100% + 48px);
    padding-left:24px;
    box-sizing: border-box;
    background: #fff;
    box-shadow: 0px -5px 5px -5px rgba(0, 0, 0, 0.2);
  }
}
::v-deep.bottom_bar{
  .align-right{
    text-align: left;
  }

  &.bottom_bar_0 {
    left: 0 !important;
  }
}
.shipperCreate{
  height: 100%;
}

.config-node-page-no {
  margin-bottom: 0;
  .no-ware-house-contract {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

</style>
